import {LoadingOverlay} from "@/components/table/neo-table/loaderNggrid";
import {routesColor} from "@/data";
import {routePlanService} from "@/service/routePlan.service";
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState
} from "react";
type RouteGpsLoacton = {
  [routeId: number]: {
    refData: RefRouteDetail_RP[];
    userBoarding: UserBoarding_RP[];
  };
};
type VariantMapContextType = {
  setCheckedRouteId: React.Dispatch<React.SetStateAction<any | []>>;
  checkedRouteId: any; //Selected route data
  routeGpsLocations: RouteGpsLoacton | any;
  routeColors: string[];
  setRouteIdBasedColors: React.Dispatch<
    React.SetStateAction<Record<number, string>>
  >;
  refreshSingleRoute: (routeId: number) => Promise<void>;
  unMappedUsers: any;
  setUnMappedUsers: any;
  setVariantRoutesData: any;
  variantRoutesData: VariantRoutesData[] | null;
  previewUserLocations: PreviewUserLocation_RP[];
  setPreviewUserLocations: React.Dispatch<
    React.SetStateAction<PreviewUserLocation_RP[]>
  >;
  vehicleFences: VehicleFenceGroups_RP;
  setVehicleFences: React.Dispatch<React.SetStateAction<VehicleFenceGroups_RP>>;
};
const VariantMapContext = createContext<VariantMapContextType>([] as any);

export function VariantMapProvider({children}: {children: ReactNode}) {
  const [loading, setLoading] = useState<boolean>(false);
  const [checkedRouteId, setCheckedRouteId] = useState([]); //Selected route data
  const [unMappedUsers, setUnMappedUsers] = useState<UnMappedLocation[] | []>(
    []
  ); //Selected route data

  const [routeGpsLocations, setRouteGpsLocations] = useState<
    Record<number, RouteGpsLoacton[]>
  >({});
  const [routeIdBasedColors, setRouteIdBasedColors] = useState<
    Record<number, string>
  >({});
  const [variantRoutesData, setVariantRoutesData] = useState<
    VariantRoutesData[] | null
  >(null);
  const [previewUserLocations, setPreviewUserLocations] = useState<
    PreviewUserLocation_RP[]
  >([]);
  const [vehicleFences, setVehicleFences] = useState<VehicleFenceGroups_RP>({
    small: [],
    medium: []
  });
  const routeColors = useMemo(() => routesColor, []);
  const fetchRouteData = async (routeId: number, colorCode: string) => {
    //setLoading(true);
    await routePlanService
      .onGetrouteInfo(routeId, colorCode)
      .then((response: RouteData_RP | null) => {
        if (response) {
          // console.log("Route Info", response);
          // setRouteGpsLocations(response);
          updateRouteGps(
            routeId,
            response.refRouteDetails,
            response.routeDetails,
            response.userBoardings,
            colorCode
          );
        } else {
          //setRouteGpsLocations([] as any);
        }
      })
      .finally(() => {
        //setLoading(false);
      });
  };
  useEffect(() => {
    // console.log("checkedRouteId", checkedRouteId);

    if (checkedRouteId && checkedRouteId.length > 0) {
      checkedRouteId.forEach((routeId: number) => {
        if (!Object.prototype.hasOwnProperty.call(routeGpsLocations, routeId)) {
          const colorCode = routeIdBasedColors[routeId] || "#999";
          fetchRouteData(routeId, colorCode);
        }
      });
    } else {
      //setRouteGpsLocations(null as any);
    }
  }, [checkedRouteId]);

  const updateRouteGps = useMemo(
    () =>
      (
        routeId: number,
        refData: RefRouteDetail_RP[],
        routeDetails: RouteDetails_RP,
        userBoarding: UserBoarding_RP[],
        colorCode: string
      ) => {
        setRouteGpsLocations((prev: any) => {
          return {
            ...prev,
            [routeId]: {
              refData: refData,
              userBoarding: userBoarding,
              routeDetails: routeDetails,
              colorCode: colorCode
            }
          };
        });
      },
    [routeGpsLocations]
  );

  const refreshSingleRoute = async (routeId: number) => {
    const colorCode = routeIdBasedColors[routeId] || "#999";

    // optional: remove only this route so fetch runs clean
    setRouteGpsLocations(prev => {
      const copy = {...prev};
      delete copy[routeId];
      return copy;
    });

    await fetchRouteData(routeId, colorCode);
  };
  return (
    <VariantMapContext.Provider
      value={{
        checkedRouteId,
        setCheckedRouteId,
        routeGpsLocations,
        routeColors,
        setRouteIdBasedColors,
        refreshSingleRoute,
        setUnMappedUsers,
        unMappedUsers,
        setVariantRoutesData,
        variantRoutesData,
        previewUserLocations,
        setPreviewUserLocations,
        vehicleFences,
        setVehicleFences
      }}
    >
      {loading ? <LoadingOverlay /> : children}
    </VariantMapContext.Provider>
  );
}
export function useVariantMap() {
  const ctx = useContext(VariantMapContext);
  if (!ctx)
    throw new Error("useVariantMap must be used within VariantMapProvider");
  return ctx;
}
